<template>
  <page-content v-if="hasPermission('report_export')" page-title="Xuất báo cáo tồn bưu cục">
    <panel title="Nhập thông tin">

      <b-row>
        <b-col>
          <c-date-picker label="Ngày" v-model="reportDay"/>
        </b-col>

        <b-col>
          <button class="btn btn-success" style="margin-top : 27px" type="submit"  @click="submit">
            <i class="fas fa-search"></i> Tìm kiếm
          </button>
        </b-col>
      </b-row>
    </panel>
    <panel title="Kết quả tìm kiếm">
      <c-table ref="table"
               lazy
               :data-filter="dataSearch"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã shop'},
                   {text: 'Số lượng Shop'},
                   {text: 'Số lượng SKU'},
                   {text: 'Số lượng sản phẩm'},
                   {text: 'Số lượng nhập mới'},
                   {text: 'Số lượng xuất khác bán'},
                   {text: 'Số lượng hàng hoàn'}
               ]"
               uri="report-service/v1.0/report/station/inventory">
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.station_name }}</td>
          <td class="text-center">{{ item.count_shop }}</td>
          <td class="text-center">{{ item.count_sku }}</td>
          <td class="text-center">{{ item.count_product_inventory }}</td>
          <td class="text-center">{{ item.count_product_import }}</td>
          <td class="text-center">{{ item.count_product_output_other }}</td>
          <td class="text-center">{{ item.count_product_refund }}</td>
        </template>
      </c-table>
    </panel>
    <b-col class="text-right">
      <button class="btn btn-success" v-if="downloadable" @click="downloadItem('ReportStationInventory.xls')">
        <i class="fas fa-download"></i> Download
      </button>
      <button class="btn btn-secondary" v-else disabled>
        <i class="fas fa-download"></i> Download
      </button>
    </b-col>
  </page-content>
</template>

<script>
export default {
  name: "StationInventory",
  data(){
    return {
      downloadable: false,
      reportDay : new Date(),
      linkDownload : '',
    }
  },
  computed:{
    dataSearch(){
      return this.convertDateToInteger(this.reportDay);
    }
  },
  methods: {
    submit() {
      let reportDay = this.convertDateToInteger(this.reportDay);
      this.$refs.table.reload();
      this.$reportService.get("/v1.0/report/station/inventory?report_day="+reportDay
      ).then(success => {
        this.linkDownload = success.data.data;
        console.log(this.linkDownload);
        if(this.linkDownload === "") {
          this.$error('Không tồn tại dữ liệu');
          this.downloadable = false;
        } else {
          this.$success();
          this.downloadable = true;
        }
      }).catch(error => {
        this.errorNotify(error)
        .then(error => {
          this.$error(error.response.data.message);
        })
      });
    },

    async downloadItem(label) {
      const axios = require('axios');
      const response = await axios.get(this.linkDownload, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
      this.downloadable = false;
    },
    convertDateToInteger(date) {
      let today = date;
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = today.getFullYear();
      let number = yyyy*10000 + mm*100 + dd*1;
      return number;
    }
  }
}
</script>

<style scoped>

</style>